// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1nAu6","containerItemsCenter":"Skeleton_containerItemsCenter__1cduj"};